import { render, staticRenderFns } from "./newHead.vue?vue&type=template&id=0291079f&scoped=true"
import script from "./newHead.vue?vue&type=script&lang=js"
export * from "./newHead.vue?vue&type=script&lang=js"
import style0 from "./newHead.vue?vue&type=style&index=0&id=0291079f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0291079f",
  null
  
)

export default component.exports